import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import translations from '@/i18n/translations';

const I18nContext = createContext(null);

const LANGS = [
  { code: 'es', label: 'ES', name: 'Espanol' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
];

export function useI18n() {
  return useContext(I18nContext);
}

export { LANGS };

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem('clubdemanri_lang');
    return saved && translations[saved] ? saved : 'es';
  });

  const setLang = useCallback((code) => {
    if (translations[code]) {
      setLangState(code);
      localStorage.setItem('clubdemanri_lang', code);
    }
  }, []);

  const t = useCallback((key) => {
    return translations[lang]?.[key] || translations['es']?.[key] || key;
  }, [lang]);

  const value = useMemo(() => ({ t, lang, setLang, LANGS }), [t, lang, setLang]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}
